import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateTransitTimeArActions } from "store/ducks/settings/transit-time-ar";

export function* createTransitTimeRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/dow-transit-times-ar`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateTransitTimeArActions.success(data));
    notify("success", "Transit cadastrado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateTransitTimeArActions.failure(errorMessage));
  }
}
